<template>
  <div id="clientes">
    <div class="card">
      <div class="card-body">
        <h4 class="fw-bolder mb-4">Clientes</h4>
        <div class="text-right"></div>
        <div v-if="loading" class="text-center">
          <div class="loadingio-spinner-ripple-6armq16mc04">
            <div class="ldio-2tzb8vdk7pu">
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
        <div v-else>
          <div>
            <div class="input-group mt-2 mb-2 mr-sm-2">
              <input
                v-model="search"
                v-on:keyup="getClientes"
                type="text"
                class="form-control"
                placeholder="Buscar cliente"
              />
            </div>
            <div v-if="clientes.length != 0" class="mt-3">
              <div class="table-responsive">
                <table
                  class="table table-bordered table-hover table-condensed my_table_2"
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nombres y apellidos</th>
                      <th>Email</th>
                      <th>Identificación</th>
                      <th>Teléfono</th>
                      <th>Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(cliente, index) in clientes" v-bind:key="index">
                      <td>{{ index + 1 }}.</td>
                      <td>{{ cliente.nombres }} {{ cliente.apellidos }}</td>
                      <td>{{ cliente.email }}</td>
                      <td>{{ cliente.identificacion }}</td>
                      <td>{{ cliente.telefono }}</td>
                      <td class="text-center">
                        <button
                          @click="index_sel = index"
                          data-bs-toggle="modal"
                          data-bs-target="#editar"
                          class="btn btn-primary btn-sm"
                        >
                          <i class="fa fa-edit"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="text-center mt-3 mb-2" v-html="paginate"></div>
            </div>
            <div v-else>
              <div class="text-muted">
                <i class="fa-solid fa-circle-info"></i> No se han agregado
                clientes.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="editar">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header text-success">
            <h5 class="modal-title fw-bolder">Editar cliente</h5>
            <button
              id="close_editar"
              type="button"
              class="close"
              data-bs-dismiss="modal"
            >
              <span>&times;</span>
            </button>
          </div>
          <div v-if="index_sel != null" class="modal-body">
            <div class="form-group">
              <label>Nombres </label>
              <input
                v-model="clientes[index_sel].nombres"
                type="text"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label>Apellidos </label>
              <input
                v-model="clientes[index_sel].apellidos"
                type="text"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label>Email</label>
              <input
                v-model="clientes[index_sel].identificacion"
                type="text"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label>Email</label>
              <input
                v-model="clientes[index_sel].email"
                type="email"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label>Teléfono </label>
              <input
                v-model="clientes[index_sel].telefono"
                type="text"
                class="form-control"
              />
            </div>

            <div class="text-end">
              <button
                v-on:click="updateCliente"
                class="btn btn-success btn-rounded btn-sm btn-icon-text"
              >
                <i class="fa fa-save"></i> Guardar
              </button>
              <button
                data-bs-dismiss="modal"
                class="btn btn-outline-dark btn-rounded btn-sm btn-icon-text ms-1"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
export default {
  name: "Clientes",
  metaInfo: {
    title: "Clientes - Backoffice",
  },
  data() {
    return {
      loading: true,
      page: 1,
      search: null,
      clientes: [],
      paginate: null,
      index_sel: null,
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.page = this.$route.params.page;
    this.getClientes();
  },
  methods: {
    getClientes: function () {
      const vm = this;

      var search = null;
      if (this.search != null && this.search.length > 3) {
        search = this.search;
        if (this.page != 1) {
          this.page = 1;
          this.$router.push("/clientes/1");
        }
      }
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": vm.$api_key,
        Token: vm.session.usuario.token_session,
      };
      let config = {
        headers: headers,
        params: {
          page: this.page,
          search: search,
        },
      };
      axios
        .get(vm.$base_url + "admin/clientes", config, {
          headers: headers,
        })
        .then((response) => {
          if (response.data.status) {
            vm.clientes = response.data.data.clientes;
            vm.get_paginate(response.data.data.total_pages);
          } else {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Clientes",
              text: response.data.message,
            });
          }
          vm.loading = false;
        })
        .catch((error) => {
          vm.$notify({
            group: "foo",
            type: "error",
            title: "Clientes",
            text: error,
          });
          vm.loading = false;
        });
    },
    updateCliente: function () {
      const vm = this;
      var valida = true;
      if (
        this.clientes[this.index_sel].nombres == null ||
        this.clientes[this.index_sel].nombres.trim().length == 0
      ) {
        vm.$notify({
          group: "foo",
          type: "error",
          title: "Error",
          text: "Digita el nombre del usuario.",
        });
        valida = false;
      }
      if (
        this.clientes[this.index_sel].apellidos == null ||
        this.clientes[this.index_sel].apellidos.trim().length == 0
      ) {
        vm.$notify({
          group: "foo",
          type: "error",
          title: "Error",
          text: "Digita los apellidos del usuario.",
        });
        valida = false;
      }
      if (
        this.clientes[this.index_sel].email == null ||
        this.clientes[this.index_sel].email.trim().length == 0
      ) {
        vm.$notify({
          group: "foo",
          type: "error",
          title: "Error",
          text: "Digita el correo electrónico del usuario.",
        });
        valida = false;
      }
      var re = /\S+@\S+\.\S+/;
      var valida_email = re.test(this.clientes[this.index_sel].email);
      if (!valida_email) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Error",
          text: "Digita una dirección de correo electrónico válida.",
        });
        valida = false;
      }
      if (!valida) {
        return false;
      }
      vm.loading = true;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        Token: vm.session.usuario.token_session,
      };
      var params = {
        data: this.clientes[this.index_sel],
      };
      axios
        .post(this.$base_url + "admin/updateCliente", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
            vm.loading = false;
            return false;
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Bien!",
              text: response.data.message,
            });
            vm.getClientes();
            vm.loading = false;
          }

          vm.loading = false;
        })
        .catch((error) => {
          vm.error_manager(error);
        })
        .finally();
    },
    get_paginate: function (tpages) {
      var page = this.page;

      if (page === undefined || page <= 0) {
        this.page = 1;
        page = this.page;
      }

      var adjacents = 4;
      var paginate = null;

      paginate = '<ul class="pagination justify-content-center text-center">';
      // previous label
      if (page == 1) {
        paginate +=
          "<li class='paginate_button page-item previous disabled'><a class='page-link disabled'> <i class='fa fa-chevron-left'></i> </a></li>";
      } else if (page == 2) {
        paginate +=
          "<li class='paginate_button page-item  previous'><a href='#/clientes/1' class='page-link' href='javascript:void(0);'> <i class='fa fa-chevron-left'></i> </a></li>";
      } else {
        var page_ant = parseFloat(page) - 1;
        paginate +=
          "<li class='paginate_button page-item'><a href='#/clientes/" +
          page_ant +
          "' class='page-link' href='javascript:void(0);'> <i class='fa fa-chevron-left'></i> </a></li>";
      }
      // first label
      if (page > parseFloat(adjacents) + 1) {
        paginate +=
          "<li class='paginate_button page-item'><a class='page-link' href='#/clientes/1'>1</a></li>";
      }
      // interval
      if (page > parseFloat(adjacents) + 2) {
        paginate += "<li class='paginate_button page-item'> <a> ... </a> </li>";
      }
      // pages
      var pmin =
        page > adjacents ? parseFloat(page) - parseFloat(adjacents) : 1;
      var pmax =
        page < parseFloat(tpages) - parseFloat(adjacents)
          ? parseFloat(page) + parseFloat(adjacents)
          : tpages;

      for (var i = pmin; i <= pmax; i++) {
        if (i == page) {
          paginate +=
            "<li class='paginate_button page-item active'><a href='#/clientes/" +
            i +
            "' class='page-link'>" +
            i +
            "</a></li>";
        } else if (i == 1) {
          paginate +=
            "<li class='paginate_button page-item'><a href='#/clientes/" +
            i +
            "' class='page-link' href='javascript:void(0);'>" +
            i +
            "</a></li>";
        } else {
          paginate +=
            "<li class='paginate_button page-item'><a href='#/clientes/" +
            i +
            "' class='page-link' href='javascript:void(0);'>" +
            i +
            "</a></li>";
        }
      }
      // interval
      if (page < parseFloat(tpages) - parseFloat(adjacents) - 1) {
        paginate += "<li class='paginate_button page-item'> <a> ... </a> </li>";
      }
      // last
      if (page < parseFloat(tpages) - parseFloat(adjacents)) {
        paginate +=
          "<li class='paginate_button page-item'><a  href='#/clientes/" +
          tpages +
          "' class='page-link' href='javascript:void(0);'>" +
          tpages +
          "</a></li>";
      }
      // next
      if (page < tpages) {
        var page_next = parseFloat(page) + 1;
        paginate +=
          "<li class='paginate_button page-item next'><a  href='#/clientes/" +
          page_next +
          "' class='page-link' href='javascript:void(0);'> <i class='fa fa-chevron-right'></i> </a></li>";
      } else {
        paginate +=
          "<li class='paginate_button page-item next disabled'><a class='page-link disabled'> <i class='fa fa-chevron-right'></i> </a></li>";
      }
      paginate += "</ul>";
      this.paginate = paginate;
    },
    error_manager: function (error) {
      let vm = this;
      let message = error;
      if (error.response.status != undefined && error.response.status == 401) {
        message = error.response.data.message;
        localStorage.removeItem("sess_vyt_backoffice");
        location.reload();
      }
      vm.$notify({
        group: "foo",
        type: "error",
        title: "Error",
        text: message,
      });
      vm.loading = false;
    },
  },
  watch: {
    $route() {
      this.page = this.$route.params.page;
      this.getClientes();
    },
  },
};
</script>
